<template lang="html">
  <div>
    <select @change="setColoris($event)" value="Abalone" class="coloris">
      <option v-for="c in coloris" :value="c.name">Corian {{c.name}} ({{c.group}})</option>
    </select>
    <select v-model="finition" @change="setDevis()" class="coloris">
      <option value="mat">Mat</option>
      <option value="satine">Satiné</option>
    </select>
    <div class="color-name">
      {{curColoris}}
    </div>
  </div>
</template>

<script>
import {coloris, groups} from '../../assets/configuration.js'

export default {
  data () {
    return {
      curColoris: 'Abalone',
      curGroup: 4,
      coloris,
      finition: 'mat',
      price: 0,
      groups
    }
  },
  methods: {
    setColoris (e) {
      var newSrc = e.target.value.toLowerCase()
      newSrc = newSrc.replace(/ /g, '_')
      this.$emit('changeColor', {src: newSrc, name: e.target.value})
      this.curColoris = e.target.value
      var colObj = this.coloris.find((el) => { return el.name === this.curColoris })
      this.curGroup = colObj.group
      this.setDevis()
    },
    setDevis () {
      this.$store.commit('setDevis', {id: 0, set: {coloris: this.curColoris, finition: this.finition, group: this.curGroup}})
    }
  }
}
</script>

<style lang="css">
.color-name {
  font-weight: bold;
  color: #000;
  font-size: 20px;
  height: 120px;
  width: 120px;
  border: 4px solid;
  display: flex;
  align-items: flex-end;
  padding: 10px;
  position: absolute;
  right: 30px;
  top: 50px;
  justify-content: flex-end;
  text-align: right;
  font-family: Helvetica, sans-serif;
}
select.coloris {
  padding: 0px 15px;
}
</style>



// WEBPACK FOOTER //
// Coloris.vue?304794ec